import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import MainContextProvider from "./main/context/MainContextProvider.tsx";
import DashboardContextProvider from "./modules/dashboard/context/DashboardContexProvider.tsx";
import { ClientClusterUsinaFilterContextProvider } from "./main/context/ClientClusterUsinaFilterContextProvider.tsx";
import { BrowserRouter } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <MainContextProvider>
        <ClientClusterUsinaFilterContextProvider>
          <DashboardContextProvider>
            <App />
          </DashboardContextProvider>
        </ClientClusterUsinaFilterContextProvider>
      </MainContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
